import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { AddNewRoleComponent } from '../components/add-new-role/add-new-role.component';
import { ListRolesComponent } from '../components/list-roles/list-roles.component';
import { RolesRoutingModule } from './role-routing.module';
import { RoleComponent } from './role.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxPaginationModule, } from 'ngx-pagination';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatMenuModule } from '@angular/material/menu'





@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    RolesRoutingModule,
    MatPaginatorModule,
    NgxPaginationModule,
    MatIconModule,
    MatTabsModule,
    MatCardModule,
    SharedModule,
    MatMenuModule,



  ],
  declarations:
    [RoleComponent, AddNewRoleComponent, ListRolesComponent,
    ]
})
export class RolesModule { }
